import { Button, Modal, ModalHeader} from 'semantic-ui-react'
import ReferralOutTableData from './ReferralOutTableData'
import FamilyView from '../BillingDetailsModal/FamilyView';

interface Props {
	hideDetailsModal : any
    detailsModalType: any
    detailsModal: any
    onSelectEvent: any
    sendReport: any
    reportData: any
    eventClick: any
    eventDate: any
    productionPrice: any
    startDate: any
    showPracticeList: any
    practicePriceList: any
    todayProduction: any,
    practiceList: any,
    openFamilyView?:Function
    selectedPractice?:any
    selectedPT_Num?:any
    selectedPracticeName?:any
    familyData?:any
    changeTab?:any
    statuses: any
    auth:any
}

function ReferralDetailsModal(props: Props) {
    const { reportData, detailsModalType, detailsModal, eventDate, practiceList, eventClick } = props;

    const getTableData = () => {
        if (!reportData || detailsModalType === 'familyView' || (detailsModal === 'report' && reportData === null)) {
            return {};
        }

        const dataKeyMap: { [key: string]: string } = {
            oralRefOut: 'oralRefOut',
            orthoRefOut: 'orthoRefOut',
            oralRefIn: 'oralRefIn',
            orthoRefIn: 'orthoRefIn',
            referin: 'referin',
            referout: 'referout',
            earnings: 'patients'
        };
        const dataKey = dataKeyMap[detailsModalType];
        let data = (dataKey && reportData[dataKey]) ? reportData[dataKey] : {};

        if (eventClick === 'day') {
            return data[eventDate] ? { [eventDate]: data[eventDate] } : {};
        }
        return data;
    }

    const tableData = getTableData();
    const tableDataArray = Object.values(tableData).flat();

    const getTitle = (detailsModalType: string) => {
        const titles: { [key: string]: string } = {
            familyView: 'Patient Family View', oralRefOut: 'Oral Surgery Referrals (Out)', oralRefIn: 'Oral Surgery Referrals (In)',
            orthoRefOut: 'Ortho Referrals (Out)', referin: 'Ortho Referrals (In)', orthoRefIn: 'Ortho Referrals (In)'
        };
        return titles[detailsModalType] || '';
    }

    return(
      <Modal
        open={true}
        onClose={props.hideDetailsModal}
        centered={true}
        className={detailsModalType === 'familyView' ? 'onFamilyView' : ''}
        size={detailsModalType === 'familyView' ? 'fullscreen' : 'large'}
        closeIcon={true}
      >
        <ModalHeader>{getTitle(detailsModalType)}</ModalHeader>
        <Modal.Content scrolling={true}>
            {
                detailsModalType === 'familyView' ?
                    <FamilyView selectedPractice={props.selectedPractice} selectedPT_Num={props.selectedPT_Num} selectedPracticeName={props.selectedPracticeName} BrokenChildTable={props.familyData} BrokenChild={props.familyData.brokenListChild} changeTab={props.changeTab} /> :
                    <ReferralOutTableData
                        detailsModal={detailsModal}
                        reportData={tableDataArray}
                        openFamilyView={props.openFamilyView}
                        practiceList={practiceList}
                        statuses={props.statuses}
                        auth={props.auth}
                    />
            }
        </Modal.Content>

        {tableDataArray.length > 0 &&
          <Modal.Actions>
            <Button primary={true} className="mr10" onClick={() => props.sendReport(tableDataArray, 'ReferralReport', detailsModalType, getTitle(detailsModalType)) }>
              Send Report
            </Button>
          { (detailsModalType !== 'earnings' && detailsModal === 'report') && <Button secondary={true} className="mr-0" onClick={() => props.onSelectEvent({ type: detailsModalType, id: eventDate }, 'details', eventClick) }>
            Report Details
          </Button> }
        </Modal.Actions>
        }
      </Modal>
    );

}

export default ReferralDetailsModal;
